import "./Header.css";
import React from "react";
import { Col } from "react-bootstrap";
import headerImage from "../../assets/images/headerBg.png";
import { Link, useNavigate } from "react-router-dom";
export const Header = (props) => {
  const navigate = useNavigate();
  return (
    <Col
      lg={8}
      sm={12}
      onClick={() => {
        navigate("/");
      }}
      className="header"
    >
      <Link to="/">
        <img src={headerImage} alt="Header" className="w-100 mobile-header" />
      </Link>
    </Col>
  );
};
